<template>
  <div id="page-wrapper">
    <!-- <div id="header2">
      <nav id="nav">
        <img
          class="imagetran"
          src="https://provide-street.oss-cn-shanghai.aliyuncs.com/app/image/36571d0c027841b6a16ad96fa941f355.png"
          alt=""
          @click="goLink('Home')"
        />
        <ul>
          <li
            :class="currentRouteName == 'Home' ? 'linkactive' : ''"
            :style="{
              '--after-width': currentRouteName == 'Home' ? '100%' : '0',
            }"
          >
            <router-link to="/">
              <a> 首页</a>
            </router-link>
          </li>
          <li
            :class="currentRouteName == 'policy' ? 'linkactive' : ''"
            :style="{
              '--after-width': currentRouteName == 'policy' ? '100%' : '0',
            }"
          >
            <router-link to="/policy">
              <a>政策法规</a>
            </router-link>
          </li>
          <li
            :class="currentRouteName == 'vipBox' ? 'linkactive' : ''"
            :style="{
              '--after-width': currentRouteName == 'vipBox' ? '100%' : '0',
            }"
          >
            <router-link to="/vipBox">
              <a>会员单位</a>
            </router-link>
          </li>
          <li
            :class="currentRouteName == 'newBox' ? 'linkactive' : ''"
            :style="{
              '--after-width': currentRouteName == 'newBox' ? '100%' : '0',
            }"
          >
            <router-link to="/newBox">
              <a>新闻动态</a>
            </router-link>
          </li>
          <li
            :class="currentRouteName == 'contact' ? 'linkactive' : ''"
            :style="{
              '--after-width': currentRouteName == 'contact' ? '100%' : '0',
            }"
          >
            <router-link to="/contact">
              <a> 联系我们</a>
            </router-link>
          </li>
          <li
            :class="currentRouteName == 'About' ? 'linkactive' : ''"
            :style="{
              '--after-width': currentRouteName == 'About' ? '100%' : '0',
            }"
          >
            <router-link to="/About">
              <a>关于协会</a>
            </router-link>
          </li>
          <li
            :class="currentRouteName == 'signUp' ? 'linkactive' : ''"
            :style="{
              '--after-width': currentRouteName == 'signUp' ? '100%' : '0',
            }"
          >
            <router-link to="/signUp">
              <a> 护工培训</a>
            </router-link>
          </li>
          <li
            :class="currentRouteName == 'zhaogong' ? 'linkactive' : ''"
            :style="{
              '--after-width': currentRouteName == 'zhaogong' ? '100%' : '0',
            }"
          >
            <router-link to="/zhaogong">
              <a> 招工需求</a>
            </router-link>
          </li>
        </ul>
      </nav>
    </div> -->
    <HeaderNav></HeaderNav>
    <div class="imageBox">
      <div class="p1 animate__animated animate__zoomIn">政策法规</div>
      <!-- <div class="p2 animate__animated animate__zoomIn">
        行业政策最新消息，了解协会规章制度
      </div> -->
    </div>
    <div class="newBannerBox">
      <div class="bannerBox2">
        <div class="menu-container">
          <div
            @click="get_newsList(35)"
            :class="type == 35 ? 'active' : ''"
            class="menu-item"
          >
            上级文件
            <div class="progress-bar"></div>
          </div>
          <!-- <div
            @click="get_newsList(36)"
            :class="type == 36 ? 'active' : ''"
            class="menu-item"
          >
            规章制度
            <div class="progress-bar"></div>
          </div> -->
          <div
            @click="get_newsList(37)"
            :class="type == 37 ? 'active' : ''"
            class="menu-item"
          >
            协会文件
            <div class="progress-bar"></div>
          </div>
        </div>
      </div>
      <div class="new_main_box">
        <div class="bottomBox">
          <template>
            <div
              class="bottom_flex"
              v-for="(item, index) in list"
              :key="index"
              @click="goDetails(item.id)"
            >
              <!-- <div class="bottom_img">
                <img
                  class="image"
                  :src="item.imageUrl ? item.imageUrl : src"
                  alt=""
                />
                <AnimatedImage
                  class="image imagetran"
                  :imageSrc="item.imageUrl ? item.imageUrl : src"
                />
              </div> -->
              <div class="bottom_text">
                <div class="p1">{{ item.title }}</div>
                <div class="p2">{{ item.remark1 }}</div>
                <div class="bottom_text_bottom">
                  <div><i class="el-icon-top-right"></i></div>
                  <div class="p3">{{ item.releaseTime | timeformat('short')}}</div>
                </div>
              </div>
            </div>
          </template>
        </div>
        <div style="text-align: center">
          <el-pagination
            background
            :current-page="pageNum"
            :page-sizes="[10, 20]"
            :page-size="pageSize"
            layout="prev, pager, next"
            :total="total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            @prev-click="handlePrevClick"
            @next-click="handleNextClick"
          />
        </div>
      </div>
    </div>

    <About></About>
  </div>
</template>
    
    
    <script>
import AnimatedImage from "./AnimatedImage.vue";
import "../assets/css/main.css";
import "../assets/css/noscript.css";
import HeaderNav from "../components/HeaderNav.vue";

import { newsList } from "../api/index";
import About from "./Footer.vue";
export default {
  name: "Home",
  components: {
    // 注册组件
    About,
    AnimatedImage,
    HeaderNav
  },
  data() {
    return {
      pageNum: 0,
      pageSize: 10,
      total: 0,
      list: [],
      type: 35,
      currentRouteName: "",
      src: "https://provide-street.oss-cn-shanghai.aliyuncs.com/app/image/3288746951724b2a82a91791d5e7e96d.png",
    };
  },
  methods: {
    goLink(name){
      this.$router.push({
        name: name,
      });
    },
    goDetails(id) {
      this.$router.push({
        name: "newDetails",
        query: {
          id: id,
          name: "培训通知",
          router:"policy",
          image:
            "https://provide-street.oss-cn-shanghai.aliyuncs.com/app/image/9434bb03a43a47269d439666993d569b.png",
        },
      });
    },
    isActive(path) {
      console.log(path, this.$route.path);
      return this.$route.path === path;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.get_newsList(this.type);
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.get_newsList(this.type);
    },
    handlePrevClick() {
      this.pageNum--;
      this.get_newsList(this.type);
    },
    handleNextClick() {
      this.pageNum++;
      this.get_newsList(this.type);
    },
    get_newsList(type) {
      this.type = type;
      const params = {
        accId: 1,
        newType: type, //行业资讯,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      };
      console.log(999, params);
      newsList(params, this.pageNum, this.pageSize).then((res) => {
        console.log(res);
        if (res.code == 200) {
          this.list = res.dataMap.list;
          this.total = res.dataMap.total;
        } else {
          this.$message(res.message);
        }
      });
    },
  },
  mounted() {
    this.currentRouteName = this.$route.name;
    console.log(741, this.$route.query.type);
    if (this.$route.query.type) {
      this.type = this.$route.query.type;
    }
    this.get_newsList(this.type);
    // 添加 IntersectionObserver 逻辑
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (
          entry.isIntersecting &&
          !entry.target.classList.contains("animation-triggered")
        ) {
          entry.target.classList.add("fade-in", "animation-triggered");
        }
      });
    });

    const animatedElements = document.querySelectorAll(
      ".bannerBox2, .bannerBox2, .new_top_box, .bottomBox,.bottom_flex,.new_main_box"
    );
    animatedElements.forEach((element) => {
      observer.observe(element);
    });
  },
  created() {},
};
</script>
    
  <style scoped>
html {
  font-size: 20px;
}

/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #0ba29a !important;
  color: #ffffff !important;
}

/deep/ .el-pagination button{
  width: 30px !important;
}
.menu-container {
  width: 10em;
  /* border-right: 1px solid #ccc; */
  padding: 10px;
}

.menu-item {
  position: relative;
  padding: 10px;
  cursor: pointer;
}

.menu-item:hover {
  /* background-color: #D9D9D9; */
  color: #0ba29a;
}

.menu-item .progress-bar {
  position: absolute;
  height: 2px;
  background-color: #0ba29a;
  width: 0;
  left: 0;
  bottom: 0;
  transition: width 0.3s ease;
}

.menu-item:hover .progress-bar {
  width: 100%;
}

.el-pagination {
  float: none !important;
  font-size: 20px !important;
}

.active {
  color: #0ba29a !important;
  font-weight: 500;
}

.first-item .progress-bar {
  width: 100%;
}

.active1 {
  color: #ffffff;
}

.imageBox {
  background-image: url("https://provide-street.oss-cn-shanghai.aliyuncs.com/app/image/e9eb6f129f244484952c9aa3520c47c2.png");
  background-size: 100% 100%;
  color: #fff;
  padding: 12em 18em 12em 18em;
  cursor: default;
  height: 28em;
  text-align: left;
}

.imageBox .p1 {
  font-family: OPPOSans;
  font-weight: 400;
  font-size: 3em;
  color: #222222;
  margin-bottom: 50px;
}

.imageBox .p2 {
  font-family: OPPOSans;
  font-weight: 400;
  font-size: 1.5em;
  color: #222222;
}

.new_main_box {
  border-left: 1px solid #d9d9d9;
  padding: 0em 0em 2.45em 2.45em;
}

.new_top_box {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.new_top_flex {
  width: 12em;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.new_top_flex .image {
  max-width: 100%;
  height: auto;
}

.new_top_flex .btn {
  position: relative;
  display: inline-block;
  background: #0ba29a;
  color: #fff;
  text-align: center;
  /* border-radius: 0.5em; */
  text-decoration: none;
  padding: 0.65em 3em 0.65em 3em;
  border: 0;
  cursor: pointer;
  outline: 0;
  font-weight: 300;
  width: 200px;
  -moz-transition: background-color 0.35s ease-in-out, color 0.35s ease-in-out,
    border-bottom-color 0.35s ease-in-out;
  -webkit-transition: background-color 0.35s ease-in-out,
    color 0.35s ease-in-out, border-bottom-color 0.35s ease-in-out;
  -ms-transition: background-color 0.35s ease-in-out, color 0.35s ease-in-out,
    border-bottom-color 0.35s ease-in-out;
  transition: background-color 0.35s ease-in-out, color 0.35s ease-in-out,
    border-bottom-color 0.35s ease-in-out;
}

.new_top_flex .btn:hover {
  color: #fff;
  background: #097c76;
}

.new_top_flex .p1 {
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 1.5em;
  line-height: 2em;
  color: #333333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.new_top_flex .p2 {
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 1em;
  line-height: 2em;
  color: #333333;
  
}

.new_top_flex .btn {
  margin-top: 30px;
}

.bottomBox {
  width: 100%;
  margin-top: 2em;
}

.bottom_flex {
  width: 100%;
  padding: 0.8em 0;
  display: flex;
  justify-content: start;
}

.bottom_img {
  width: 12em;
  height: 7.5em;
  margin-right: 1.995em;
}
.bottom_img .image {
  max-width: 100%;
  height: 7.5em;
}

.bottom_text {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  cursor: pointer;
}

.bottom_text .p1 {
  font-family: PingFang SC;
  font-size: 1.3em;
  color: #333333;
  font-weight: 800;
  overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-line-clamp: 1;
	-webkit-box-orient: vertical;
}

.bottom_text .p1:hover {
  color: #097c76;
  cursor: pointer;
}
.bottom_text .p2 {
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 0.8em;
  color: #666666;
  overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
}

.bottom_text .p2:hover {
  color: #097c76;
  cursor: pointer;
}

.bottom_text_bottom {
  display: flex;
  justify-content: space-between;
}
.bottom_text_bottom .image {
  width: 1.333em;
  height: 1.333em;
}
.bottom_text_bottom .p3 {
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 1.064em;
  color: #666666;
}

.newBannerBox {
  display: flex;
  padding: 3.1em 18em;
  background-color: #ffffff;
}

.bannerBox2 > ul {
  line-height: 80px;
  position: relative;
  margin: 0;
  height: 80px;
  line-height: 80px;
  display: flex;
  justify-content: center;
  list-style-type: none;
  margin: 0;
  padding: 0;
  overflow: hidden;
}

.bannerBox2 > ul:after {
  right: 100%;
  margin-right: 1px;
}

.bannerBox2 > ul > li {
  display: inline-block;
  margin: 0px 2em 0 2em;
  border: solid 1px transparent;
  -moz-transition: color 0.35s ease-in-out, border-color 0.35s ease-in-out;
  -webkit-transition: color 0.35s ease-in-out, border-color 0.35s ease-in-out;
  -ms-transition: color 0.35s ease-in-out, border-color 0.35s ease-in-out;
  transition: color 0.35s ease-in-out, border-color 0.35s ease-in-out;
  color: #333;
}

.bannerBox2 > ul > li > a,
.bannerBox2 > ul > li > span {
  display: block;
  color: inherit;
  text-decoration: none;
  border: 0;
  outline: 0;
}

.bannerBox2 > ul > li > a {
  display: block;
  color: #222222;
  text-align: center;
  text-decoration: none;
  position: relative;
}

.bannerBox2 > ul > li > a::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 4px;
  background-color: #0ba29a;
  color: #0ba29a;
  transition: width 0.1s ease;
}

.bannerBox2 > ul > li > a:hover::after {
  width: 100%;
}

.bannerBox2 > ul > li > a:hover {
  color: #0ba29a;
  font-weight: 600;
}

.bannerBox2 > ul > li > a.current-page {
  color: #0ba29a;
  font-weight: 600;
}

.bannerBox2 > ul > li > ul {
  display: none;
}

@media screen and (max-width: 1680px) {
  html {
    font-size: 16px;
  }

  .imageBox{
    padding: 12em 10em 12em 10em;
  }

  .newBannerBox{
    padding: 3.1em 10em;
  }
}

@media screen and (max-width: 1280px) {
  html {
    font-size: 14px;
  }

  .imageBox{
    padding: 12em 10em 12em 10em;
  }

  .newBannerBox{
    padding: 3.1em 10em;
  }
}

@media screen and (max-width: 960px) {
  html {
    font-size: 10px;
  }

  .imageBox {
    padding: 6em 3em 6em 3em;
  }

  .newBannerBox {
    padding: 3.1em 2em;
    display: block;
  }

  .menu-container {
    display: flex;
    width: 100%;
    justify-content: center;
  }

  .new_main_box {
    border: none;
  }

  .new_main_box {
    padding: 0 0;
  }
}

@media screen and (max-width: 840px) {
  html {
    font-size: 10px;
  }

  .imageBox {
    padding: 6em 3em 6em 3em;
  }

  .newBannerBox {
    padding: 3.1em 2em;
    display: block;
  }

  .menu-container {
    display: flex;
    width: 100%;
    justify-content: center;
  }

  .new_main_box {
    border: none;
  }

  .new_main_box {
    padding: 0 0;
  }
}

@media screen and (max-width: 736px) {
  html {
    font-size: 10px;
  }

  .imageBox {
    padding: 6em 3em 6em 3em;
  }

  .newBannerBox {
    padding: 3.1em 2em;
    display: block;
  }

  .menu-container {
    display: flex;
    width: 100%;
    justify-content: center;
  }

  .new_main_box {
    border: none;
  }

  .new_main_box {
    padding: 0 0;
  }
}
</style>
    
    